<script setup>
import { computed } from 'vue'
import { defaultVTooltipProps } from '@/utils/defaultProps'

const props = defineProps({
  checkBoxValue: { type: [String, Number, Boolean], required: true },
  value: { type: null },
  title: { type: String },
  tooltipTitle: { type: String },
  listItemClass: { type: String, default: '' },
  titleClass: { type: String, default: '' },
  trueValue: { type: [String, Number, Boolean], default: 'all' },
  falseValue: { type: [String, Number, Boolean], default: 'none' },
  indeterminateValue: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  tooltipSide: { type: String, default: 'right' },
})

const emit = defineEmits(['input'])

const isChecked = computed(() => props.checkBoxValue === props.trueValue)

function onClick() {
  emit('input', { checked: !isChecked.value, value: props.value })
}

const activatorId = computed(() => {
  const sanitized = String(props.value ?? '')
    .replace(/<[^>]*>/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^A-Za-z0-9_-]/g, '-')

  return `v-list-item-action-${sanitized}`
})

const isDescriptionHelpful = computed(() => {
  return props.tooltipTitle && props.title !== props.tooltipTitle
})
</script>

<template>
  <v-list-item-group :id="activatorId">
    <v-list-item
      dense
      :disabled="disabled"
      class="hover-bg-primary"
      :class="listItemClass"
      :value="isChecked"
      @click="onClick"
    >
      <v-list-item-action
        class="mr-2 my-1"
        @click.stop="onClick"
      >
        <v-simple-checkbox
          :value="isChecked"
          :indeterminate="indeterminateValue"
          color="primary"
          :ripple="false"
          @click.stop="onClick"
        />
      </v-list-item-action>

      <v-list-item-content>
        <v-list-item-title :class="titleClass">
          <span
            v-if="title"
            v-html="title"
          />
        </v-list-item-title>
      </v-list-item-content>

      <v-list-item-icon>
        <v-progress-circular
          v-if="loading"
          indeterminate
          :size="15"
          :width="2"
          color="primary"
          class="mx-auto my-auto"
        />

        <v-icon
          v-else-if="isDescriptionHelpful"
          small
        >
          mdi-information-outline
        </v-icon>
      </v-list-item-icon>
    </v-list-item>

    <v-menu
      v-if="isDescriptionHelpful"
      :activator="`#${activatorId}`"
      :close-on-content-click="false"
      v-bind="defaultVTooltipProps"
      max-height="20rem"
      open-on-hover
      offset-x
      nudge-top="20"
    >
      <v-card>
        <v-card-text>
          <span v-html="tooltipTitle" />
        </v-card-text>
      </v-card>
    </v-menu>

    <!-- <v-tooltip
      v-if="tooltipTitle && isDescriptionHelpful"
      :activator="`#${activatorId}`"
      :right="props.tooltipSide === 'right'"
      :left="props.tooltipSide === 'left'"
      v-bind="defaultVTooltipProps"
      open-on-hover
      content-class="text-wrap text-break text-black-50"
      :open-on-focus="false"
      :open-on-click="false"
      color="white"
    >
      <span
        style="white-space: pre-line"
        v-html="tooltipTitle"
      ></span>
    </v-tooltip> -->
  </v-list-item-group>
</template>

<style scoped>
.hover-bg-primary {
  transition: background-color 0.15s ease-in-out;
}
.hover-bg-primary:hover {
  background-color: rgba(var(--v-primary-base-rgb, 25, 118, 210), 0.08);
}
</style>
